export default __webpack_public_path__ + "images/f93cdc08a33ff31828f444418fa2c5da-investment.jpg";